<script setup>
  import {provide, reactive} from "vue";

  defineOptions({
    name: "ComponentAccordion",
  });

  const state = reactive({
    selectedId: null,
  });

  let nextId = 0;

  const register = (initOpened) => {
    const id = ++nextId;
    if (initOpened && state.selectedId === null) {
      state.selectedId = id;
    }
    return id;
  };

  const unregister = (id) => {
    if (state.selectedId === id) {
      state.selectedId = null;
    }
  };

  const select = (id) => {
    state.selectedId = state.selectedId === id ? null : id;
  };

  provide("accordionProvider", {state, register, unregister, select});
</script>

<template>
  <div>
    <div class="overflow-hidden rounded-md border border-gray-300 bg-white">
      <ul class="divide-y divide-gray-300">
        <slot />
      </ul>
    </div>
  </div>
</template>
